/**
 * Runs `fn` once the browser has nothing better to do, and at the latest after `timeoutMs` (faster-screens):
 * for work the first screen does not need, such as fetching a chunk a later tap will want. Safari has no
 * `requestIdleCallback`, so it gets a plain timer. Returns a cancel function, for an effect's cleanup.
 */
export function whenIdle(fn: () => void, timeoutMs = 2000): () => void {
  if (typeof window.requestIdleCallback === 'function') {
    const id = window.requestIdleCallback(fn, { timeout: timeoutMs });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(fn, Math.min(timeoutMs, 500));
  return () => window.clearTimeout(id);
}
